import client from '../base-api';

const serviceURL = '/coach-billing';

const coachBillingService = {

    // ACCOUNTANT ------------------
    // 1. Existed bills
    getExistingBillsList(filterData: any) {
        return client.get(`${serviceURL}/existing-bills`, {params: filterData});
    },
    getBillDetails(id: number) {
        return client.get(`${serviceURL}/bill-details/${id}`);
    },
    privateCoachingBillCancellation(id: number) {
        return client.put(`${serviceURL}/private-coaching/cancellation-bill/${id}`);
    },
    groupCoachingHourlyWagesBillCancellation(id: number) {
        return client.put(`${serviceURL}/group-coaching/hourly-wages-cancellation-bill/${id}`);
    },
    groupCoachingPauschalBillCancellation(id: number) {
        return client.put(`${serviceURL}/group-coaching/pauschal-cancellation-bill/${id}`);
    },
    assistedLivingCoachingBillCancellation(id: number) {
        return client.put(`${serviceURL}/assisted-living-coaching/cancellation-bill/${id}`);
    },
    caseManagementCoachingBillCancellation(id: number) {
        return client.put(`${serviceURL}/case-management-coaching/cancellation-bill/${id}`);
    },

    // 2. Pending bills
    getPendingBillsList(filterData: any) {
        return client.get(`${serviceURL}/pending-bills`, {params: filterData});
    },
    countUnreadMessagesForAccountant() {
        return client.get(`${serviceURL}/pending-bills/count-unread-messages-for-accountant`);
    },
    sendChatMessageAsAccountant(data: any) {
        return client.post(`${serviceURL}/pending-bills/send-chat-message-accountant`, data);
    },
    setMessageAsSeen(billId: number) {
        return client.put(`${serviceURL}/pending-bills/set-message-for-accounting-as-seen/${billId}`);
    },
    rejectPendingBillAsAccountant(data: any, billId: number) {
        return client.put(`${serviceURL}/pending-bills/reject/${billId}`, data);
    },
    createBillAfterApproving(billId: number) {
        return client.put(`${serviceURL}/pending-bills/create-bill-after-approving/${billId}`);
    },
    showReasonForRejectionOfPendingBill(billId: number) {
        return client.get(`${serviceURL}/pending-bills/show-reason-for-rejection/${billId}`);
    },


    // 3. Creating bills
    // Private coaching
    privateCoachingPreviewList(filterData: any) {
        return client.get(`${serviceURL}/private-coaching/preview-list`, {params: filterData});
    },
    createPrivateCoachingBill(filters: any){
        return client.post(`${serviceURL}/private-coaching/create-bill`, filters);
    },
    createPrivateCoachingTempBill(filters: any){
        return client.post(`${serviceURL}/private-coaching/create-temp-bill`, filters);
    },

    // Group coaching
    groupCoachingPreviewList(filterData: any) {
        return client.get(`${serviceURL}/group-coaching/preview-list`, {params: filterData});
    },
    createGroupCoachingBill(filters: any){
        return client.post(`${serviceURL}/group-coaching/create-bill`, filters);
    },
    createGroupCoachingTempBill(filters: any){
        return client.post(`${serviceURL}/group-coaching/create-temp-bill`, filters);
    },

    // Assisted living coaching
    assistedLivingCoachingPreviewList(filterData: any) {
        return client.get(`${serviceURL}/assisted-living-coaching/preview-list`, {params: filterData});
    },
    createAssistedLivingCoachingBill(filters: any){
        return client.post(`${serviceURL}/assisted-living-coaching/create-bill`, filters);
    },
    createAssistedLivingCoachingTempBill(filters: any){
        return client.post(`${serviceURL}/assisted-living-coaching/create-temp-bill`, filters);
    },


    // Case management coaching
    caseManagementCoachingPreviewList(filterData: any) {
        return client.get(`${serviceURL}/case-management-coaching/preview-list`, {params: filterData});
    },
    createCaseManagementCoachingBill(filters: any){
        return client.post(`${serviceURL}/case-management-coaching/create-bill`, filters);
    },
    createCaseManagementCoachingTempBill(filters: any){
        return client.post(`${serviceURL}/case-management-coaching/create-temp-bill`, filters);
    },




    // COORDINATOR -------------------------
    coordinatorCountNotifications() {
        return client.get(`${serviceURL}/coordinator/count-notification`);
    },
    coordinatorCountUnreadMessages() {
        return client.get(`${serviceURL}/coordinator/count-unread-messages`);
    },
    coordinatorSendChatMessage(data: any) {
        return client.post(`${serviceURL}/coordinator/send-chat-message-coordinator`, data);
    },
    coordinatorSetMessageAsSeen(billId: number) {
        return client.put(`${serviceURL}/coordinator/set-message-as-seen/${billId}`);
    },
    coordinatorGetPendingBills(filterData: any) {
        return client.get(`${serviceURL}/coordinator/pending-bills`, {params: filterData});
    },
    coordinatorGetRejectedBills(filterData: any) {
        return client.get(`${serviceURL}/coordinator/rejected-bills`, {params: filterData});
    },
    coordinatorExistedBills(filterData: any) {
        return client.get(`${serviceURL}/coordinator/existing-bills`, {params: filterData});
    },
    coordinatorApproveBill(billId: number){
        return client.put(`${serviceURL}/coordinator/approve-bill/${billId}`);
    },
    coordinatorRejectBill(data: any, billId: number) {
        return client.put(`${serviceURL}/coordinator/reject-bill/${billId}`, data);
    },

}

export default coachBillingService;